import { LogbookLoadingsPayload, StateLogbook } from "../types";

export const logbookLoadings = (state: StateLogbook, action: LogbookLoadingsPayload): StateLogbook => {
    return { ...state, loadings: { ...state.loadings, [action.name]: action.value } }
}